import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useField } from 'react-final-form';
import DraftListingFields from 'components/DraftListingFields';

import './SecondStep.styles.scss';

type SecondStepProps = {
  className?: string;
  dealRoomId?: string;
};

const SecondStep: React.FC<SecondStepProps> = (props) => {
  const { className, dealRoomId } = props;

  // Named on the first step of the same form, and the AI events want it alongside
  // the deal id.
  const {
    input: { value: dealName },
  } = useField<string>('name', { subscription: { value: true } });

  const classes = classNames('second-step', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <h1>{t('nextStep')}</h1>

      <DraftListingFields
        dealRoomId={dealRoomId}
        dealName={dealName}
        fieldName="uploadListingIM"
        basedOnFieldName="createListing"
      />
    </div>
  );
};

export default SecondStep;
